import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DisplayDto } from '../../../../../api/gen';
import { Role } from 'shared-lib';
import { RoleService } from '../../../../auth/role-service';

@Component({
  selector: 'app-zone-display',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './zone-display.component.html',
  styleUrl: './zone-display.component.scss'
})
export class ZoneDisplayComponent implements OnInit {
  private roleService = inject(RoleService);

  @Input() display!: DisplayDto;
  @Input() isProcessing = false;
  @Output() deleteDisplay = new EventEmitter<string>();
  @Output() editDisplay = new EventEmitter<DisplayDto>();
  @Output() testHeartbeat = new EventEmitter<string>();
  @Output() unassignDisplay = new EventEmitter<string>();

  isAdmin = signal(false);
  isSendingHeartbeat = signal(false);

  async ngOnInit(): Promise<void> {
    this.isAdmin.set(await this.roleService.checkAccess(Role.Administrator));
  }

  onDelete(): void {
    if (this.display?.id) {
      this.deleteDisplay.emit(this.display.id);
    }
  }

  onEdit(): void {
    if (this.display) {
      this.editDisplay.emit(this.display);
    }
  }

  onTestHeartbeat(): void {
    if (this.display?.id) {
      this.testHeartbeat.emit(this.display.id);
    }
  }

  onUnassign(): void {
    if (this.display?.id) {
      this.unassignDisplay.emit(this.display.id);
    }
  }
}
